<template>
  <span v-show="!viewMenuData.isOpenMenu" class="selected-menu-container">
    <span class="selected-menu-text" :title="viewMenuData.selectedMenu?.name">
      {{ viewMenuData.selectedMenu?.name }}
    </span>
    <span class="fold-icon" @click="switchMenu"></span>
  </span>
</template>

<script lang="ts" setup name="SelectedViewMenu">
import { emitOpenMenuChange, ViewMenuData } from '../config'

const props = withDefaults(defineProps<{viewMenuData: ViewMenuData}>(), {
  viewMenuData: () => ({
    selectedMenu: () => ({}),
    isOpenMenu: false,
  })
})

function switchMenu() {
  props.viewMenuData.isOpenMenu = !props.viewMenuData.isOpenMenu;
  emitOpenMenuChange(props.viewMenuData.isOpenMenu)
}

</script>

<style lang="less" scoped>
.selected-menu-container {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #262626;
}
.selected-menu-text {
  display: inline-block;
  max-width: 112px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 8px;
}
.fold-icon {
  display: inline-block;
  transform: rotate(180deg);
  // 上传的icon字体展示有误，用svg文件
  background-image: url('../assets/fold-icon.svg');
  background-size: cover;
  width: 28px;
  height: 28px;
  cursor: pointer;
  &:hover {
    background-image: url('../assets/fold-hover-icon.svg');
  }
}
</style>
